import React, {
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from 'react';
import './styles.css';
import FiltersContentLoader from '../../../../components/FiltersContentLoader';
import LoadMask from '../../../../components/LoadMask';
import PagePagination from '../../../../components/PagePagination';
import ENDPOINT from '../../../../constants/endpoints';
import {useGrid} from '../../../../hooks/useGrid';
import ApplicantHistoryWidgetItem from './components/ApplicantHistoryWidgetItem';

const ApplicantHistoryWidget = forwardRef((props, ref) => {
  const {
    data: { isFetching, page, pagesCount, perPage, rows, rowsCount },
    actions: { readPage, fetch },
  } = useGrid(ENDPOINT.COLLECTION.APPLICANT_HISTORY, null, false);

  useImperativeHandle(ref, () => ({
    refresh: () => fetch(),
  }));

  useEffect(() => {
    fetch();
  }, []);

  const history = useMemo(
    () =>
      rows.map(row => (
        <ApplicantHistoryWidgetItem key={row.CandidateID} row={row} />
      )),
    [rows]
  );

  return !isFetching ? (
    !!Number(rowsCount) && (
      <div className="sidebar__widget">
        {isFetching && <LoadMask relative />}
        <div className="sidebar__block">
          <h4 className="sidebar__title">Applicant History</h4>
        </div>

        <div className="sidebar__block">
          <div className="sidebar__table">
            <div className="sidebar__table-row sidebar__table-row--head">
              <div className="sidebar__table-column sidebar__table-column--head">
                Candidate
              </div>
              <div className="sidebar__table-column sidebar__table-column--head">
                LTM App
              </div>
              <div className="sidebar__table-column sidebar__table-column--head">
                Date
              </div>
            </div>
            {history}
            {pagesCount > 1 && (
              <PagePagination
                page={page}
                perPage={perPage}
                count={rowsCount}
                pageRangeDisplayed={3}
                controlFunc={readPage}
                hideFirstLastPages={false}
                hideNavigation={true}
                minimalStyle={true}
                scrollToTop={false}
              />
            )}
          </div>
        </div>
      </div>
    )
  ) : (
    <FiltersContentLoader />
  );
});

export default ApplicantHistoryWidget;
